
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.9 28.238l21 21.12a1 1 0 01.02 1.42 1 1 0 01-.7.29 1.001 1.001 0 01-.71-.3l-17.78-17.83 7.17 18.23a1 1 0 01-.57 1.3.922.922 0 01-.36.07 1 1 0 01-.93-.64l-8.87-22.53-12.69-12.76a1.001 1.001 0 111.41-1.42l9.44 9.48-6-15.31a1 1 0 011.86-.73l7.71 19.61z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.8 36.818a3.78 3.78 0 00-3.78 3.78 3.79 3.79 0 003.78 3.78 3.79 3.79 0 003.79-3.78 3.79 3.79 0 00-3.79-3.78zm-.8 6a2.236 2.236 0 01-.49-.24l3.25-3.24c.096.151.176.312.24.48l-3 3zm1.62-4.37l-2.993 2.993c.055.17.13.334.223.487l3.25-3.24c-.15-.1-.31-.18-.48-.24zm-1.2-.13l-1.91 1.89a2.35 2.35 0 011.91-1.92v.03zm2.032 3.942a2.34 2.34 0 01-1.205.631l1.863-1.863a2.34 2.34 0 01-.658 1.232z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.61 33.828H14a4 4 0 00-4 4v5.62a4 4 0 004 4h5.61a4 4 0 004-4v-5.62a4 4 0 00-4-4zm2.46 9.58a2.46 2.46 0 01-2.46 2.46H14a2.46 2.46 0 01-2.46-2.46v-5.62a2.46 2.46 0 012.46-2.46h5.61a2.46 2.46 0 012.46 2.46v5.62z"}})])
          )
        }
      }
    